import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { ShieldCheck, ShieldX } from "lucide-react";

export default function ConfirmGuardianPage() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: "loading", childName: "" });

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setState({ status: "error" });
      return;
    }
    api
      .get(`/guardian/confirm?token=${encodeURIComponent(token)}`)
      .then(({ data }) => setState({ status: "ok", childName: data.child_name }))
      .catch(() => setState({ status: "error" }));
  }, [params]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-[#121212] border border-[#262626] rounded-sm p-8 text-center" data-testid="confirm-guardian-page">
        <h1 className="font-display text-3xl uppercase tracking-tight text-white mb-4">EGNCY</h1>
        {state.status === "loading" && <p className="text-[#a3a3a3]">Confirming…</p>}
        {state.status === "ok" && (
          <>
            <ShieldCheck className="w-10 h-10 text-white mx-auto mb-3" />
            <p className="text-white font-semibold" data-testid="confirm-guardian-success">
              Guardian access confirmed for {state.childName}.
            </p>
            <p className="text-sm text-[#a3a3a3] mt-2">
              Log in (or create an account with this email) and open the Family tab to see their activity.
            </p>
            <Link to="/login" className="inline-block mt-5 px-6 py-2 bg-white text-black font-semibold rounded-sm hover:bg-gray-200 text-sm">
              Go to login
            </Link>
          </>
        )}
        {state.status === "error" && (
          <>
            <ShieldX className="w-10 h-10 text-[#737373] mx-auto mb-3" />
            <p className="text-white" data-testid="confirm-guardian-error">Invalid or expired confirmation link.</p>
          </>
        )}
      </div>
    </div>
  );
}
